export default "__VITE_ASSET__BRE_Bcp2__"